import * as React from "react";

import { WithStyles } from "@material-ui/core";
import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";

type ClassNames = "container";

const styles = (theme: Theme): StyleRules<ClassNames> => ({
    container: {
        minWidth: "100vw",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box"
    }
});

interface FSProps {
    children?: React.ReactNode;
    className?: string;
    id?: string;
    style?: React.CSSProperties
}

class FS extends React.Component<WithStyles<ClassNames> & FSProps> {
    public render() {
        const {classes, className, id, style} = this.props;
        return (
            <div className={[classes.container, className].join(" ")} {...{id, style}}>
                {this.props.children}
            </div>
        );
    }
}

export default withStyles(styles)<FSProps>(FS);



// WEBPACK FOOTER //
// ./src/components/FS.tsx